import { dimensions, SvgIconProps } from "./SvgIcon";

export function SparkleIcon(props: SvgIconProps) {
  const { width, height } = dimensions(props);
  return (
    <svg
      width={width}
      height={height}
      style={props.style}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.62508 12.8327V9.91602M2.62508 4.08268V1.16602M1.16675 2.62435H4.08341M1.16675 11.3743H4.08341M7.58341 1.74935L6.57181 4.37952C6.4073 4.80724 6.32505 5.02109 6.19714 5.20098C6.08378 5.36041 5.94448 5.49971 5.78505 5.61307C5.60516 5.74098 5.3913 5.82324 4.96358 5.98775L2.33341 6.99935L4.96358 8.01095C5.3913 8.17546 5.60516 8.25771 5.78505 8.38562C5.94448 8.49899 6.08378 8.63828 6.19714 8.79771C6.32505 8.9776 6.4073 9.19146 6.57181 9.61918L7.58342 12.2493L8.59502 9.61918C8.75953 9.19146 8.84178 8.9776 8.96969 8.79772C9.08305 8.63828 9.22235 8.49899 9.38178 8.38562C9.56167 8.25771 9.77553 8.17546 10.2032 8.01095L12.8334 6.99935L10.2032 5.98774C9.77553 5.82324 9.56167 5.74098 9.38178 5.61307C9.22235 5.49971 9.08305 5.36041 8.96969 5.20098C8.84178 5.02109 8.75953 4.80724 8.59502 4.37952L7.58341 1.74935Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
